import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { IndividualTherapy } from './pages/IndividualTherapy';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="3ka4br4374fke">
      <Routes data-id="element-1" data-mp="3k8jeh6phyiiu">
        <Route path="/" element={<Home data-id="element-3" data-mp="3k78ezj333wxj" />} data-id="element-2" data-mp="3k92qy7wdoeph" />
        <Route path="/therapy/individual" element={<IndividualTherapy data-id="element-5" data-mp="3fbt14r52u114" />} data-id="element-4" data-mp="3farfjsqfpw55" />
      </Routes>
    </BrowserRouter>;
}